import axios from 'axios';

  export const getDahsboardData = async (batchId, userId, programName) => {
    try {
      const response = await axios.get(
        `https://api.iamironlady.com/api/get-zoho-program-engagement-detail?batchId="${batchId}"&userId=${userId}&programName="${programName}"`)
      return response;
     
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      throw error;
    }
  };
